var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDeleteCarouselProspects(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icDeleteCarouselProspects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.3550055,23.5000564 L34.9198107,14.9352412 C35.7082113,14.1468397 35.7082113,12.8685916 34.9198107,12.0803028 C34.1314101,11.2919013 32.8532762,11.2919013 32.0648756,12.0803028 L23.4999577,20.6452308 L14.9350398,12.08019 C14.1466392,11.2917885 12.8685053,11.2917885 12.0801047,12.08019 C11.2918169,12.8685916 11.2918169,14.1468397 12.0801047,14.9351284 L20.6450227,23.4999436 L12.0801047,32.0648716 C11.2918169,32.8532731 11.2918169,34.1315212 12.0801047,34.91981 C12.8685053,35.7082115 14.1466392,35.7082115 14.9350398,34.91981 L23.4999577,26.354882 L32.0648756,34.91981 C32.8531634,35.7082115 34.1314101,35.7082115 34.9198107,34.91981 C35.7082113,34.1314084 35.7082113,32.8532731 34.9198107,32.0648716 L26.3550055,23.5000564 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prospects-Likes-Swipe-Copy",
    transform: "translate(-63.000000, -1427.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icDeleteCarouselProspects",
    transform: "translate(63.000000, 1427.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,0.5 C13.7764153,0.5 0.5,13.7764153 0.5,30 C0.5,46.2235847 13.7764153,59.5 30,59.5 C46.2235847,59.5 59.5,46.2235847 59.5,30 C59.5,13.7764153 46.2235847,0.5 30,0.5 Z",
    id: "Stroke-1",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "UI/icon/close-x-Profile",
    transform: "translate(6.562500, 6.562500)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/white",
    mask: "url(#mask-2)",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "colour/light-grey",
    points: "0 0 47 0 47 47 0 47"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeleteCarouselProspects);
export default __webpack_public_path__ + "static/media/icDeleteCarouselProspects.39333ae2e749cce1eadcd845219aa4a5.svg";
export { ForwardRef as ReactComponent };